import menuRegistrationListing from './menuRegistrationListing';
import menuMovementListing from './menuMovementListing';
import menuProcessing from './menuProcessing';
import menuDocument from './menuDocument';
import menuPaymentReceipt from './menuPaymentReceipt';

export default [
  menuRegistrationListing,
  menuMovementListing,
  menuProcessing,
  menuDocument,
  menuPaymentReceipt,
];
